// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Fork_Class from "../Control.Monad.Fork.Class/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Fusion_Data_Bytes from "../Fusion.Data.Bytes/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Generator from "../Fusion.Generator/index.js";
import * as Fusion_Impl_AppM from "../Fusion.Impl.AppM/index.js";
import * as MST_Data_BasicURL from "../MST.Data.BasicURL/index.js";
import * as MST_Data_StreamEvent from "../MST.Data.StreamEvent/index.js";
import * as WE_Class_AVar from "../WE.Class.AVar/index.js";
import * as WE_Class_MonadRef from "../WE.Class.MonadRef/index.js";
import * as WE_Class_Time from "../WE.Class.Time/index.js";
import * as Web_XHR_ProgressEvent from "../Web.XHR.ProgressEvent/index.js";
var form2toForm1 = /* #__PURE__ */ Fusion_Generator.form2toForm1(Fusion_Impl_AppM.manageAVarAVarAppM)(Fusion_Impl_AppM.monadForkAppFiberAppMFSEr)(Fusion_Impl_AppM.monadKillFSErrorAppFiberA)(Fusion_Impl_AppM.monadErrorAppM);
var bind = /* #__PURE__ */ Control_Bind.bind(Fusion_Impl_AppM.bindAppM);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Fusion_Impl_AppM.bindAppM);
var pure = /* #__PURE__ */ Control_Applicative.pure(Fusion_Impl_AppM.applicativeAppM);
var now = /* #__PURE__ */ WE_Class_Time.now(Fusion_Impl_AppM.monadTimeAppM);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var bracket = /* #__PURE__ */ Control_Monad_Fork_Class.bracket(Fusion_Impl_AppM.monadBracketFSErrorAppFib);
var when = /* #__PURE__ */ Control_Applicative.when(Fusion_Impl_AppM.applicativeAppM);
var $$void = /* #__PURE__ */ Data_Functor["void"](Effect_Aff.functorAff);
var empty = /* #__PURE__ */ WE_Class_AVar.empty(Fusion_Impl_AppM.manageAVarAVarAppM);
var $$new = /* #__PURE__ */ WE_Class_MonadRef["new"](Fusion_Impl_AppM.monadRefRefAppM);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Fusion_Data_Bytes.monoidBytes);
var fork = /* #__PURE__ */ Control_Monad_Fork_Class.fork(Fusion_Impl_AppM.monadForkAppFiberAppMFSEr);
var delay = /* #__PURE__ */ WE_Class_Time.delay(Fusion_Impl_AppM.monadTimeAppM);
var read = /* #__PURE__ */ WE_Class_MonadRef.read(Fusion_Impl_AppM.monadRefRefAppM);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Fusion_Impl_AppM.monadEffectAppM);
var sequence_ = /* #__PURE__ */ Data_Foldable.sequence_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe);
var put = /* #__PURE__ */ WE_Class_AVar.put(Fusion_Impl_AppM.manageAVarAVarAppM);
var max = /* #__PURE__ */ Data_Ord.max(Fusion_Data_Bytes.ordBytes);
var put1 = /* #__PURE__ */ WE_Class_MonadRef.put(Fusion_Impl_AppM.monadRefRefAppM);
var kill_ = /* #__PURE__ */ Fusion_Generator.kill_(Fusion_Impl_AppM.monadKillFSErrorAppFiberA);
var void1 = /* #__PURE__ */ Data_Functor["void"](Fusion_Impl_AppM.functorAppM);
var take = /* #__PURE__ */ WE_Class_AVar.take(Fusion_Impl_AppM.manageAVarAVarAppM);
var xhrInfiniteUploadStreamerDi = function (uploadStreamer) {
    return function (config) {
        return form2toForm1(function (emit) {
            var loop = function (gen) {
                return bind(Fusion_Generator.next(gen))(function (val) {
                    if (val.payload instanceof MST_Data_StreamEvent.Start) {
                        return loop(gen);
                    };
                    if (val.payload instanceof MST_Data_StreamEvent.ResponseStart) {
                        return loop(gen);
                    };
                    if (val.payload instanceof MST_Data_StreamEvent.LoadedBytes) {
                        return discard(emit(val))(function () {
                            return loop(gen);
                        });
                    };
                    if (val.payload instanceof MST_Data_StreamEvent.ResponseEnd) {
                        return pure(true);
                    };
                    if (val.payload instanceof MST_Data_StreamEvent.Fail) {
                        return discard(emit(val))(function () {
                            return pure(false);
                        });
                    };
                    if (val.payload instanceof MST_Data_StreamEvent.Abort) {
                        return discard(emit(val))(function () {
                            return pure(false);
                        });
                    };
                    if (val.payload instanceof MST_Data_StreamEvent.TransmissionStats) {
                        return loop(gen);
                    };
                    throw new Error("Failed pattern match at Fusion.Streamers.UploadXHR (line 55, column 7 - line 71, column 43): " + [ val.payload.constructor.name ]);
                });
            };
            return bind(now)(function (timestamp) {
                return discard(emit({
                    payload: MST_Data_StreamEvent.Start.value,
                    timestamp: timestamp
                }))(function () {
                    return bind(now)(function (timestamp$prime) {
                        return discard(emit({
                            payload: MST_Data_StreamEvent.ResponseStart.value,
                            timestamp: timestamp$prime
                        }))(function () {
                            var externalLoop = function (i) {
                                var url = MST_Data_BasicURL.addQueryParameter("iteration")(new Data_Maybe.Just(show(i)))(config.url);
                                return bind(bracket(uploadStreamer({
                                    url: url,
                                    byteCount: config.byteCount
                                }))(function (v) {
                                    return function (gen) {
                                        return Fusion_Generator.cancel(gen);
                                    };
                                })(loop))(function (shouldContinue) {
                                    return when(shouldContinue)(externalLoop(i + 1 | 0));
                                });
                            };
                            return externalLoop(0);
                        });
                    });
                });
            });
        });
    };
};
var runIgnoringErrors = function (action) {
    return Effect_Aff.launchAff_($$void(Fusion_Impl_AppM.runAppM(action)));
};
var runErrorFree = function (action) {
    return Effect_Aff.launchAff_($$void(Fusion_Impl_AppM.runAppM(action)));
};
var xhrUploadStreamer = function (v) {
    return bind(empty)(function (v1) {
        return bind($$new(mempty))(function (v2) {
            return bind($$new(Data_Maybe.Nothing.value))(function (abortRef) {
                return bind(fork(discard(delay(Fusion_Data_Duration.fromMs(3000.0)))(function () {
                    return bind(read(abortRef))(function (abort) {
                        return discard(liftEffect(sequence_(abort)))(function () {
                            return bind(now)(function (timestamp) {
                                var streamEvent = {
                                    payload: new MST_Data_StreamEvent.Fail({
                                        message: "Timeout establishing connection"
                                    }),
                                    timestamp: timestamp
                                };
                                return put(streamEvent)(v1);
                            });
                        });
                    });
                })))(function (timeoutFiber) {
                    var onProgress = function (progressEvent) {
                        return runErrorFree(bind(now)(function (timestamp) {
                            var loadedNumber = Web_XHR_ProgressEvent.loaded(progressEvent);
                            var loadedInt = Data_Int.round(loadedNumber);
                            var loadedBytes = Fusion_Data_Bytes.fromInt(loadedInt);
                            return bind(read(v2))(function (v3) {
                                var bytesDelta = max(mempty)(Fusion_Data_Bytes.sub(loadedBytes)(v3));
                                return discard(put1(v2)(loadedBytes))(function () {
                                    var streamEvent = {
                                        payload: new MST_Data_StreamEvent.LoadedBytes({
                                            bytes: bytesDelta
                                        }),
                                        timestamp: timestamp
                                    };
                                    return discard(put(streamEvent)(v1))(function () {
                                        return pure(Data_Unit.unit);
                                    });
                                });
                            });
                        }));
                    };
                    var onLoadStart = runIgnoringErrors(bind(now)(function (timestamp) {
                        return discard(kill_(timeoutFiber))(function () {
                            var streamEvent = {
                                payload: MST_Data_StreamEvent.ResponseStart.value,
                                timestamp: timestamp
                            };
                            return put(streamEvent)(v1);
                        });
                    }));
                    var onLoad = runErrorFree(bind(now)(function (v3) {
                        var streamEvent = {
                            payload: MST_Data_StreamEvent.ResponseEnd.value,
                            timestamp: v3
                        };
                        return put(streamEvent)(v1);
                    }));
                    var onError = function (message) {
                        return runErrorFree(bind(now)(function (timestamp) {
                            var streamEvent = {
                                payload: new MST_Data_StreamEvent.Fail({
                                    message: message
                                }),
                                timestamp: timestamp
                            };
                            return put(streamEvent)(v1);
                        }));
                    };
                    return bind(now)(function (timestamp) {
                        var streamEvent = {
                            payload: MST_Data_StreamEvent.Start.value,
                            timestamp: timestamp
                        };
                        return discard(void1(fork(put(streamEvent)(v1))))(function () {
                            return bind(liftEffect($foreign.mkXhrImpl({
                                url: MST_Data_BasicURL.print(v.url),
                                byteLength: Fusion_Data_Bytes.toNumber(v.byteCount),
                                onProgress: onProgress,
                                onLoad: onLoad,
                                onLoadStart: onLoadStart,
                                onError: onError
                            })))(function (v3) {
                                return discard(put1(abortRef)(new Data_Maybe.Just(v3.abort)))(function () {
                                    return pure({
                                        next: take(v1),
                                        cancel: liftEffect(v3.abort)
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    });
};
var xhrInfiniteUploadStreamer = /* #__PURE__ */ xhrInfiniteUploadStreamerDi(xhrUploadStreamer);
export {
    xhrUploadStreamer
};
//# sourceMappingURL=index.js.map
